/**
 * ¿Quien opera esta pestaña es del equipo de Deenex? (rolActiva.ts, que sale del rol que devolvió el
 * canje). Re-renderiza cuando el rol cambia: al abrir la app con la sesión de persona el rol llega con
 * el primer canje, después del primer render, y las acciones del equipo tienen que aparecer (o seguir
 * escondidas) sin recargar. Si el rol está pendiente, pide el canje: una página que espera el rol para
 * mostrarse no haría ningún pedido que lo traiga.
 *
 * Decide sólo qué se MUESTRA: lo que una persona de un cliente no puede hacer lo frena el backend
 * igual (403 SOLO_EQUIPO).
 */

import { useEffect, useSyncExternalStore } from "react";
import { alCambiarRol, asegurarRol, intentoRol, rolActual, type IntentoRol, type RolActual } from "../rolActiva";

export function useRolActiva(): RolActual {
  const rol = useSyncExternalStore(alCambiarRol, rolActual, rolActual);
  useEffect(() => {
    if (rol === "pendiente") void asegurarRol();
  }, [rol]);
  return rol;
}

export function useEsEquipoDeenex(): boolean {
  return useRolActiva() === "equipo";
}

/**
 * El último intento de saber el rol (rolActiva.ts): si está en curso y, si falló, qué pasó. Lo usa la página que
 * espera el rol para no quedarse en «Cargando…» cuando el canje no anduvo (`EsperandoRol`).
 */
export function useIntentoRol(): IntentoRol {
  return useSyncExternalStore(alCambiarRol, intentoRol, intentoRol);
}

export default useEsEquipoDeenex;
